<template>
    <div style="box-sizing: border-box;padding:  0;">
        <div class="newscontent">
            <div class="bread">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/newsList' }">新闻公告</el-breadcrumb-item>
                    <el-breadcrumb-item >{{info.title}}</el-breadcrumb-item>
                </el-breadcrumb>
                <!-- <div style="height: 20px;"></div> -->
            </div>
           
            <div class="detailContent">
                <div class="detailInner">
                    <div class="newsTitle" v-text="info.title"></div>
                    <div class="newsTime" v-text="info.addtime_text"></div>
                    <div class="newsDi" v-html="info.content">
                        
                    </div>
                </div>
                <div class="prnx flx alc jsb" v-if="info.next_news || info.top_news">
                    <div v-if="info.top_news" @click="checkdetail(info.top_news.id)" class="pr cursor flx" style="align-items: baseline;">
                        <div>上一篇:</div> <div class="single" style="max-width: 300px;" v-text="info.top_news.title"></div>
                    </div>
                    <div v-if="!info.top_news"></div>
                    <div v-if="info.next_news" @click="checkdetail(info.next_news.id)" class="nx cursor flx" style="align-items: baseline;">
                        <div>下一篇:</div><div class="single" style="max-width: 300px;" v-text="info.next_news.title"></div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
</template>
<script>
    import {
        newsDetail
    } from "@/api/index.js"
    export default {
        data() {
            return {
                info:{}
            }
        },
        created() {
            this.getList()
          
        },
        methods: {
            getList(){
                let that = this 
                newsDetail(that.$route.query.id).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.$nextTick(() => {
                            that.info = res.data
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
            checkdetail(e){
                let that = this
                newsDetail(e).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.$nextTick(() => {
                            that.info = res.data
                            window.scrollTo(0, 0)
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .newscontent{
        
    }
    .bread{
         width: 1248px;
         margin: 0 auto;
    }
    .newsDi{
        box-sizing: border-box;
        padding: 36px 0;
        text-align: left;
    }
    .newsTime{
        padding: 27px 0 36px 0;
        border-bottom: 1px solid #eee;
        font-weight: 500;
        font-size: 16px;
        color: #999999;
        text-align: left;
    }
    .detailContent{
        width: 100%;
        background: #ffffff;
        
    }
    .prnx{
        width: 1248px;
        box-sizing: border-box;
        padding: 24px 0;
        margin: 0 auto;
        border-top: 1px solid #ededed;
    }
    .detailInner{
        width: 1248px;
        box-sizing: border-box;
        padding: 64px 0;
        margin: 0 auto;
    }
    
    .newsTitle{
        font-weight: 600;
        font-size: 32px;
        color: #333333;
        text-align: left;
    }
</style>